import { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { LightModal } from '@repo/ui/components/Modal/LightModal';
import Button from '@repo/ui/components/Button';
import { useLinkStatus } from '../../hooks/auth/usePasswordSync';
import PasswordSyncModal from './PasswordSyncModal';
import { PASSWORD_SYNC_COPY } from './constants';

const SESSION_KEY = 'pwSyncAnnouncementDismissed';

export default function PasswordSyncAnnouncement() {
  const { data: linkStatus, isLoading } = useLinkStatus();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(SESSION_KEY) === 'true');
  const [showSyncModal, setShowSyncModal] = useState(false);

  const dismiss = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setDismissed(true);
  };

  const handleSetUpNow = () => {
    dismiss();
    setShowSyncModal(true);
  };

  const handleSyncSuccess = () => {
    setShowSyncModal(false);
  };

  if (showSyncModal) {
    return (
      <PasswordSyncModal
        isOpen
        onClose={() => setShowSyncModal(false)}
        onSuccess={handleSyncSuccess}
      />
    );
  }

  if (isLoading || dismissed || !linkStatus?.isEligible || linkStatus?.isLinked) {
    return null;
  }

  return (
    <LightModal
      isOpen
      title={PASSWORD_SYNC_COPY.announcement.title}
      onClose={dismiss}
      closeOnBackdropClick={false}
      showCloseButton={false}
      className="max-w-md"
    >
      <div className="space-y-6">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-100">
            <KeyRound className="h-8 w-8 text-blue-600" aria-hidden="true" />
          </div>
        </div>

        <p className="text-center text-sm leading-relaxed text-gray-600">
          {PASSWORD_SYNC_COPY.announcement.body}
        </p>

        <div className="flex flex-col gap-3">
          <Button onClick={handleSetUpNow} className="w-full">
            {PASSWORD_SYNC_COPY.announcement.ctaButton}
          </Button>
          <Button variant="outline" onClick={dismiss} className="w-full">
            {PASSWORD_SYNC_COPY.announcement.dismissButton}
          </Button>
        </div>
      </div>
    </LightModal>
  );
}
